import { setCurrentActiveEl, getCurrentActiveEl } from '@/core/directive/enterFocusTracker';

export default {
    mounted(el, binding) {
        el._vueInstance = binding.instance;
        const focusIndex = binding.value;

        // Save index directly on element for lookup
        el.dataset.focusIndex = focusIndex;

        if (parseFloat(focusIndex) === 1) {
            setTimeout(() => {
                focusElement(el);
                setCurrentActiveEl(el);
            }, 100);
        }

        // --- CHANGE HERE: Use focusin and mousedown ---

        // focusin catches focus on any child element (like PrimeVue's search box)
        el.addEventListener('focusin', () => {
            setCurrentActiveEl(el);
        });

        // mousedown ensures that even if focus hasn't shifted yet, clicking updates the tracker
        el.addEventListener('mousedown', () => {
            setCurrentActiveEl(el);
        });

        // Global enter handler (attach once)
        if (!window._enterHandlerAttached) {
            document.addEventListener('keydown', (e) => {
                // Agar dropdown open hai aur user Enter dabata hai to default behavior zaroori hai
                // taake item select ho jaye. Hum preventDefault ko condition mein rakhte hain.
                if (e.key !== 'Enter') return;

                const activeEl = getCurrentActiveEl();
                if (!activeEl) return;

                // Agar user kisi search box mein hai, to pehle item select hone den
                // e.preventDefault(); // Isko thora delay ke baad handle karen ya yahan rehne den

                const currentPos = parseFloat(activeEl.dataset.focusIndex);
                if (isNaN(currentPos)) return;

                const vueInstance = activeEl._vueInstance;
                const onEnterFn = activeEl.getAttribute('data-on-enter');
                if (onEnterFn && typeof vueInstance?.[onEnterFn] === 'function') {
                    vueInstance[onEnterFn]();
                }

                let nextPos = currentPos + 1;
                let nextEl = document.querySelector(`[data-focus-index="${nextPos}"]`);

                if (!nextEl) {
                    const overrideNext = activeEl.getAttribute('data-next-focus');
                    if (overrideNext) {
                        nextPos = parseFloat(overrideNext);
                        nextEl = document.querySelector(`[data-focus-index="${nextPos}"]`);
                    }
                }

                if (nextEl) {
                    e.preventDefault(); // Sirf tab prevent karen jab agla element mil jaye
                    setTimeout(() => {
                        focusElement(nextEl);
                        setCurrentActiveEl(nextEl);
                    }, 200); // 200ms delay taake dropdown band hone ka waqt milay
                }
            });

            window._enterHandlerAttached = true;
        }
    }
};

function focusElement(el) {
    if (!el) return;

    const combobox = el.querySelector('[role="combobox"]');
    if (combobox) {
        combobox.focus();
        combobox.click(); // Open dropdown

        setTimeout(() => {
            const searchInput = el.querySelector('input[role="searchbox"]') || document.querySelector('input[role="searchbox"]');
            if (searchInput) {
                searchInput.focus();
                searchInput.select();
            }
        }, 150);
        return;
    }

    // Input ya button ke liye
    const input = el.tagName === 'INPUT' ? el : el.querySelector('input');
    if (input) {
        input.focus();
        if (typeof input.select === 'function') input.select();
    } else if (typeof el.focus === 'function') {
        el.focus();
    }
}
